import React from 'react'
import { FieldBinaryOutlined, InboxOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';
import { Button, Checkbox, Form, Input, Select, InputNumber, message, Upload, Image, Dropdown } from 'antd';
// import InputMask from "react-input-mask";
import DatePicker from 'react-date-picker';

import { Col, Divider, Row, Typography } from 'antd';
import './contactInfo.css';
import { width } from '@mui/system';
import LeftControl from '../LeftControl';
import { Addressstate, CitizenStatus, MaritalStatusOptions, formatPhoneNumber, formatSSN } from '../dummyConstant/DummyConstant';
import { useState } from 'react';
import { useEffect } from 'react';
import services from '../../Services';
import axios from 'axios';
import { Grid, TextField } from '@mui/material';
import moment from 'moment-timezone';
import { useHistory } from 'react-router-dom';
import { values } from 'lodash';
import Snackbar from '../../Components/Snackbar';
import { showSnackBar } from '../../helpers/showSnackBar';
import { useDispatch } from 'react-redux';
import { setAccessTokens } from '../../redux/features/utils.slice';

const { Title } = Typography;
const { Option } = Select;
const { TextArea } = Input
const { Dragger } = Upload;




const {
    users,
    hr
} = services;

const props = {
    name: 'file',
    accept: "application/pdf,application/vnd.ms-excel",
    multiple: true,
    action: false,
    onChange(info) {
        // return
        const { status } = info.file;
        if (status == 'uploading') {
        }
        if (status === 'done') {
            message.success(`${info.file.name} file uploaded successfully.`);
        } else if (status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
        }
    },
    onDrop(e) {
    },
};



const ContactInfoForm = () => {

    const dispatch = useDispatch()
    const [form] = Form.useForm()
    const [maritalStatus, setMaritalStatus] = useState('')
    const [JobCategories, setJobCategories] = useState([])
    const [filesToUpload, setfilesToUpload] = useState({ resume: null, license: null, ssc: null })
    const [numbers, setNumbers] = useState({
        homePhone: null, cellPhone: null, spouseTelePhone: null, Telephone: null
    });

    let history = useHistory();

    const uploadPDF = (file, type) => {

        let validTypes = ["application/pdf", "image/jpeg", "image/png", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]
        if (!validTypes.includes(file[0]?.type)) {
            showSnackBar('File type not accepted!')
            let file = document.getElementById(`${type}`)
            file.value = ''
            return
        }
        setfilesToUpload({ ...filesToUpload, [type]: file, [`${type}-name`]: file[0]?.name })
    }

    const deletePDF = (type) => {
        setfilesToUpload({ ...filesToUpload, [type]: null, [`${type}-name`]: null })
    }



    const removeHttpErrorListener = () => {
        window.removeEventListener('trigger-snackbar', ($e) => {

        });
    }


    useEffect(async () => {
        let result = await hr?.get_job_categories();
        if (result && result.httpStatus == 200) {
            result?.data?.map(row => {
                row.label = row?.title;
                row.title = row?.id
            })
            setJobCategories(result?.data)
        }
    }, []);


    const getBinaryFromFile = (file) => {
        file = file[0]
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.addEventListener("load", () => resolve(reader.result));
            reader.addEventListener("error", err => reject(err));
            reader.readAsBinaryString(file);
        });
    }


    const onFinish = async (values) => {
        if (values?.email !== values?.confirmEmail) return showSnackBar("Emails do not match.")
        const birthPlace = `${values.cityBirth}, ${values.stateBirth}`;

        let data = {
            first_name: values.first_name,
            middle_name: values.middle_name || null,
            last_name: values.last_name,
            home_phone: values.home_phone,
            dob: moment(values.dob).format('MM-DD-YYYY'),
            birthPlace,
            email: values.email,
            cell_phone: values.cell_phone,
            street_address1: values.street_address1,
            street_address2: values.street_address2 || null,
            city: values.city,
            state: values.state,
            zip: values.zip,
            // ssn: values.ssn.slice(0, 3) + values.ssn.slice(4, 6) + values.ssn.slice(7, 11),
            marital_status: values.marital_status,
            us_citizen: values.us_citizen,
            spouse_name: values.spouse_name,
            spouse_date_of_birth: moment(values.spouse_date_of_birth).format('MM-DD-YYYY'),
            agree_to_notifications: values?.agree_to_notifications || false,
            spouse_address: values.spouse_address,
            spouse_telephoneNumber: values.spouse_telephoneNumber,
            emergency_contact: {
                name: values.name,
                relationship: values.relationship,
                address: values.address,
                state: values.state1,
                zip: values.emergencyZip,
                phone_number: values.phone_number,
                city: values.city1
            },
            position: {
                id: values.id,
                description: values.description,
                category: values.category,
                notes_for_hr: values.notes_for_hr
            },
            resume: filesToUpload?.resume || '',
            state_driver_license: filesToUpload?.state_driver_license || '',
            // ssc: filesToUpload?.ssc || ''
        }
        try {

            data = { ...data, cell_phone: !data?.cell_phone ? "" : data?.cell_phone }
            data.dob = data.dob.toString();
            /** Transformations */
            if (data.spouse_date_of_birth)
                data.spouse_date_of_birth =
                    data.spouse_date_of_birth.toString();
            if (data.spouse_telephoneNumber)
                data.spouse_telephoneNumber =
                    data.spouse_telephoneNumber?.toString().replace(/[^\d]/g, '');
            if (data.cell_phone)
                data.cell_phone =
                    data.cell_phone?.toString().replace(/[^\d]/g, '');

            data.home_phone = data.home_phone?.toString().replace(/[^\d]/g, '');
            data.emergency_contact.phone_number = data.emergency_contact.phone_number?.toString().replace(/[^\d]/g, '');

            let fd = new FormData();
            Object.keys(data)
                .forEach(key => {

                    const currentField = data[key];

                    const pushField = typeof currentField !== 'string'
                        ? (currentField instanceof FileList)
                            ? currentField[0]
                            : JSON.stringify(currentField)
                        : currentField;

                    fd.append(
                        key,
                        pushField
                    );
                });
            let response = await users.register(
                fd,
                {
                    'Content-Type': 'multipart/form-data'
                },
            );

            localStorage.setItem('access_jwt', response?.token);
            dispatch(setAccessTokens({ token: response?.token }))

            showSnackBar('Form Submitted')
            setTimeout(() => { history.push("/create-password"); }, 3000);
            removeHttpErrorListener();
        }
        catch (err) {

            if ((err?.response?.data?.message) == 'applicant_already_exist')

                showSnackBar("This email already Exist. Please try another email Address")
            else
                showSnackBar(err?.response?.data?.message)
        }
    };
    const onFinishFailed = async (errorInfo, data) => {
         
    };
    const onChange = (date) => {

    };

    const handlePhoneNumber = (prop, event) => {
        let formattedNumber = formatPhoneNumber(event.target.value)
        event.target.value = formattedNumber
        form.setFieldsValue({ [prop]: formattedNumber })
    }

    const handleSSNFormatting = (value) => {
        let formattedNumber = formatSSN(value)
        form.setFieldsValue({ ssn: formattedNumber })
    }


     
    return (


        <div style={{ width: '90%' }} className='content-align'>
            <Row >
                <Title level={2}>Contact Information</Title>
            </Row>
            <Row >
                <Divider className='divider' />
            </Row>
            <Row>
                <Title level={3}>Enter Information</Title>
            </Row>

            <Form
                name="basic"
                form={form}
                initialValues={{
                    remember: true,
                }}
                style={{
                    maxWidth: '900px',
                    marginBottom: '10px'
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                scrollToFirstError
            >
                <Row >

                    <Col md={8}>
                        <label>First Name</label>
                        <Form.Item

                            name="first_name"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter your First Name ',
                                },
                            ]}

                        >
                            <Input placeholder='First Name' className='w-50 input-style' />
                        </Form.Item>

                    </Col>
                    <Col md={8}>
                        <label>Middle Name(Optional)</label>
                        <Form.Item
                            // label="Username"
                            name="middle_name"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please enter your Middle Name ',
                                },
                            ]}
                        >
                            <Input placeholder='Middle Name' className='w-50 input-style' />
                        </Form.Item>

                    </Col>
                    <Col md={8}>
                        <label>Last Name</label>
                        <Form.Item
                            // label="Username"
                            name="last_name"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter your Last Name ',
                                },
                            ]}
                        >
                            <Input placeholder='Last Name' className='w-50 input-style' />
                        </Form.Item>

                    </Col>
                </Row>
                <Row>

                    <Col md={8}>
                        <label>Email Address</label>
                        <Form.Item
                            name='email'

                            rules={[
                                {
                                    required: true,
                                    type: 'email',
                                    message: 'Please enter your Email Address',

                                },
                            ]}
                        >
                            <Input placeholder='Enter Email Address' className='w-50 input-style' />
                        </Form.Item>

                    </Col>

                    <Col md={8}>
                        <label>Confirm Email Address</label>
                        <Form.Item
                            name='confirmEmail'

                            rules={[
                                {
                                    required: true,
                                    type: 'email',
                                    message: 'Please confirm email address',

                                },
                            ]}
                        >
                            <Input placeholder='Confirm Email Address' className='w-50 input-style' />
                        </Form.Item>

                    </Col>


                    <Col md={8}>
                        <label>Phone Number</label>
                        <Form.Item
                            // label="Username"
                            name="home_phone"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter Phone Number',
                                },

                            ]}
                        >


                            <Input type={'text'}
                                style={{ border: '1px solid #E5E5E5', padding: '4px' }}
                                placeholder='(xxx) xxx-xxxx'
                                className='w-50 input-style'
                                onChange={
                                    (e) => handlePhoneNumber('home_phone', e)
                                } />


                        </Form.Item>
                    </Col>




                    <Col md={8}>
                        <label>Cell Phone (Optional)</label>
                        <Form.Item
                            // label="Username"
                            name="cell_phone"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please enter your cellphone ',
                                },
                            ]}
                        >
                            {/* <InputNumber maxLength={10} minLength={10} placeholder='213(123)-1234' className='w-50 input-style' /> */}
                            <Input
                                style={{ border: '1px solid #E5E5E5', padding: '4px' }}
                                placeholder='(xxx) xxx-xxxx'
                                className='w-50 input-style'
                                onChange={
                                    (e) => handlePhoneNumber('cell_phone', e)
                                } />
                        </Form.Item>

                    </Col>
                    {/* <Col md={}>


                    </Col> */}
                    {/* <Col md={8}>
                        <label>SSN</label>
                        <Form.Item
                            // label="Username"
                            name="ssn"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter your SSN  ',
                                },
                            ]}
                        >
                            <Input onChange={
                                (e) => handleSSNFormatting(e.target.value)
                            } maxLength={11} minLength={11} placeholder='123-45-6789' className='w-50 input-style' />
                        </Form.Item>

                    </Col> */}
                </Row>
                <label>Date of Birth</label>
                <Row gutter={40}>
                    <Col md={8}>
                        <Form.Item

                            // label="Username"
                            name="dob"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter your date of birth ',
                                },

                            ]}
                        >
                            <DatePicker
                                required={true}
                                onChange={onChange}
                                style={{ background: 'white', borderRadius: '10px' }}
                                className="datePickerReact w100p bg-white react-date-picker"
                                message={'please fill this field'}
                                maxDate={new Date("02-29-9999")}
                            />
                        </Form.Item>
                    </Col>
                    </Row>
                    
                <Row className='mt-5'>
                    <Title level={5}>Birth Place</Title>
                </Row>
                    <Row>
                        
                    <Col md={8}>
                        <label>City</label>
                        <Form.Item

                            name="cityBirth"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter your city ',
                                },
                            ]}
                        >
                            <Input className='w-50 input-style' placeholder='Enter City' />
                        </Form.Item>

                    </Col>
                    <Col md={8}>
                        <label>State</label>
                        <Form.Item
                            name="stateBirth"
                            rules={[
                                {
                                    message: 'Please enter your state ',
                                    required: true,
                                },
                            ]}
                            className='w-50 input-style'
                        >
                            <Select
                                placeholder="Select an option "
                                options={Addressstate}

                                // onChange={onGenderChange}
                                showSearch
                                allowClear
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            >

                            </Select>
                        </Form.Item>

                    </Col>
                </Row>
                <Row >



                    <Col md={16}>

                        <Form.Item
                            name="agree_to_notifications"
                            valuePropName="checked"
                        >
                            <Checkbox defaultChecked={false}>Yes I agree to receive text and email notifications from  Trans Global Solutions</Checkbox>
                        </Form.Item>

                    </Col>
                </Row>


                {/* <Row style={{ marginTop: '40px' }}>

                    <Col md={24}>

                        <Form.Item
                            name="agree_to_notifications"
                            valuePropName="checked"


                        >
                            <Checkbox defaultChecked={false}>Yes I agree to receive text and email notifications from  Trans Global Solutions</Checkbox>
                        </Form.Item>

                    </Col>
                </Row> */}


                <Row className='mt-5'>
                    <Title level={4}>Home Address</Title>
                </Row>

                <Row >

                    <Col md={8} className='mt-5'>
                        <label>Street Address</label>
                        <Form.Item
                            name="street_address1"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter street Address',
                                },
                            ]}
                        >
                            <Input placeholder='Enter Street Address' className='w-50 input-style' />
                        </Form.Item>

                    </Col>

                    <Col md={8} className='mt-5'>
                        <label>Street Address 2 (Optional)</label>
                        <Form.Item
                            // label="Username"
                            name="street_address2"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please enter your street address 2 ',
                                },
                            ]}
                        >
                            <Input placeholder='Enter Street Address 2' className='w-50 input-style' />
                        </Form.Item>

                    </Col>
                </Row>

                <Row >

                    <Col md={8}>
                        <label>City</label>
                        <Form.Item

                            name="city"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter your city ',
                                },
                            ]}
                        >
                            <Input className='w-50 input-style' placeholder='Enter City' />
                        </Form.Item>

                    </Col>
                    <Col md={8}>
                        <label>State</label>
                        <Form.Item
                            name="state"
                            rules={[
                                {
                                    message: 'Please enter your state ',
                                    required: true,
                                },
                            ]}
                            className='w-50 input-style'
                        >
                            <Select
                                placeholder="Select an option "
                                options={Addressstate}

                                // onChange={onGenderChange}
                                showSearch
                                allowClear
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            >

                            </Select>
                        </Form.Item>

                    </Col>

                    <Col md={8}>
                        <label>Zip</label>
                        <Form.Item
                            // label="Username"
                            name="zip"
                            rules={[

                                {
                                    required: true,
                                    message: 'Please Enter a valid Zip Code',
                                },
                                {
                                    pattern: new RegExp("^[0-9]*$"),
                                    message: "Please Enter a valid Zip Code"
                                }

                            ]}
                        >
                            {/* <input type="number" data-maxlength="6"  /> */}
                            {/* <Input type='number' min={5} max={5} placeholder='Enter zip code' className='w-50 input-style' /> */}
                            <Input type='text'
                                maxLength="5" minLength="5" placeholder='12345' className='w-50 input-style' />
                        </Form.Item>

                    </Col>
                </Row>
                <Row>
                    <Col md={17}>
                        <label>Are you authorized to work in the US?</label>
                        <Form.Item
                            name="us_citizen"
                            // label="Gender"
                            rules={[
                                {
                                    message: 'Please enter your citizen status ',

                                    required: true,
                                },
                            ]}
                            className='w-50 input-style'
                        >
                            <Select
                                options={CitizenStatus}
                                placeholder="Select an option "
                                // onChange={onGenderChange}
                                allowClear
                                showSearch
                            >

                            </Select>
                        </Form.Item>

                    </Col>
                </Row>

                <Row >
                    <Col md={8}>
                        <label>Martial Status</label>
                        <Form.Item
                            name="marital_status"

                            rules={[
                                {
                                    message: 'Please enter your Martial status ',

                                    required: true,
                                },
                            ]}
                            className='w-50 input-style'
                        >
                            <Select
                                placeholder="Select an option "
                                onChange={(prop) => setMaritalStatus(prop)}
                                options={MaritalStatusOptions}
                                // value={MaritalStatus}
                                allowClear
                                showSearch
                            >

                            </Select>
                        </Form.Item>

                    </Col>


                </Row>
                {maritalStatus == 'married' &&
                    <Row>
                        <Col md={8} >
                            <label>Name of Spouse</label>
                            <Form.Item
                                // label="Username"
                                name="spouse_name"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Enter spouse name ',
                                    },
                                ]}
                            >
                                <Input placeholder='Enter Spouse Name' className='w-50 input-style' />
                            </Form.Item>

                        </Col>
                        <Col md={7}>
                            <label>Spouse Date of Birth</label>
                            <Form.Item
                                // label="Username"
                                name="spouse_date_of_birth"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Enter your date of Birth ',
                                    },
                                ]}
                            >

                                <DatePicker
                                    required={true}
                                    onChange={onChange}
                                    style={{ background: 'white', borderRadius: '10px', border: '1px solid black' }}
                                    className="datePickerReact  bg-white react-date-picker"
                                    message={'please fill this field'}
                                    activeStartDate={false}
                                    maxDate={new Date("02-29-9999")}

                                />
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={8} >
                            <label>Spouse's Address</label>
                            <Form.Item
                                // label="Username"
                                name="spouse_address"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Enter your spouse Address ',
                                    },
                                ]}
                            >
                                <Input placeholder='Enter Spouse Address' className='w-50 input-style' />
                            </Form.Item>

                        </Col>
                    </Row>}
                {maritalStatus == 'married' && <Row>
                    <Col md={8}>
                        <label>Spouse's Telephone Number</label>
                        <Form.Item
                            // label="Username"
                            name="spouse_telephoneNumber"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Enter your Telephone Number ',
                                },
                            ]}
                        >
                            {/* <InputNumber maxLength={10} minLength={10} placeholder='213(123)-1234' className='w-50 input-style' /> */}
                            <Input
                                className='w-50 input-style'
                                placeholder='(xxx) xxx-xxxx'
                                style={{ border: '1px solid #E5E5E5', padding: '4px' }}
                                onChange={
                                    (e) => handlePhoneNumber('spouse_telephoneNumber', e)
                                } />
                        </Form.Item>

                    </Col>
                </Row>}

                {/*--------------------------------------------------------------*/}


                <Row>
                    <Title className='mt-5' level={4}>In case of emergency, contact
                    </Title>
                </Row>

                <Row className='mt-5'>

                    <Col md={8}>
                        <label>Name</label>
                        <Form.Item
                            // label="Username"
                            name="name"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter your Name ',
                                },
                            ]}
                        >
                            <Input className='w-50 input-style' placeholder='Enter Name' />
                        </Form.Item>

                    </Col>

                    <Col md={8}>
                        <label>Relationship</label>
                        <Form.Item
                            // label="Username"
                            name="relationship"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter your relationship ',
                                },
                            ]}
                        >
                            <Input className='w-50 input-style' placeholder='Enter Relationship' />
                        </Form.Item>

                    </Col>
                    <Snackbar />
                </Row>
                <Row>
                    <Col md={17}>
                        <label>Address</label>
                        <Form.Item
                            // label="Username"
                            name="address"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please enter your Address ',
                                },
                            ]}
                        >
                            <Input placeholder='Enter Address' className='w-50 input-style' />
                        </Form.Item>
                    </Col>
                </Row>

                <Row className='mt-5' >

                    <Col md={8}>
                        <label>City</label>
                        <Form.Item

                            name="city1"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please enter your city',
                                },
                            ]}

                        >
                            <Input className='w-50 input-style' placeholder='Enter City' />
                        </Form.Item>

                    </Col>
                    <Col md={8}>
                        <label>State</label>
                        <Form.Item
                            name="state1"
                            // label="Gender"
                            rules={[
                                {
                                    message: 'Please select your state ',

                                    required: false,
                                },
                            ]}
                            className='w-50 input-style'
                        >
                            <Select
                                placeholder="Select an option "
                                // onChange={onGenderChange}
                                showSearch
                                allowClear
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }

                                options={Addressstate}
                            >

                            </Select>
                        </Form.Item>

                    </Col>

                    <Col md={8}>
                        <label>Zip</label>
                        <Form.Item
                            // label="Username"
                            name="emergencyZip"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please Enter a valid Zip Code',
                                },
                                {
                                    pattern: new RegExp("^[0-9]*$"),
                                    message: "Please Enter a valid Zip Code"
                                }
                            ]}
                        >
                            <Input type='text'
                                maxLength="5" minLength="5" placeholder='12345' className='w-50 input-style' />

                        </Form.Item>

                    </Col>
                </Row>

                <Row>
                    <Col md={8}>
                        <label>Telephone Number</label>
                        <Form.Item
                            // label="Username"
                            name="phone_number"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter your Telephone Number ',
                                },
                            ]}
                        >
                            <Input
                                style={{ border: '1px solid #E5E5E5', padding: '4px' }}
                                className='w-50 input-style'
                                placeholder='(xxx) xxx-xxxx'

                                onChange={
                                    (e) => handlePhoneNumber('phone_number', e)
                                } />

                        </Form.Item>
                    </Col>
                </Row>
                <Row className='mt-5'>
                    <Title level={4}>Position Applying For</Title>
                </Row>
                <Row className='mt-5'>

                    <Col md={8}>
                        <label>Job ID(Optional)</label>
                        <Form.Item
                            // label="Username"
                            name="id"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please Enter Job Id',
                                },
                            ]}
                        >
                            <Input className='w-50 input-style' placeholder='Enter Job ID' />
                        </Form.Item>

                    </Col>

                    <Col md={8}>
                        <label>Job Description (Optional)</label>
                        <Form.Item
                            // label="Username"
                            name="description"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please enter your job Description ',
                                },
                            ]}
                        >
                            <Input className='w-50 input-style' placeholder='Select an option' />
                        </Form.Item>

                    </Col>
                </Row>
                <Row>
                    <Col md={8}>
                        <label>Job Category</label>
                        <Form.Item
                            name="category"
                            rules={[
                                {
                                    message: 'Please select your job Category ',

                                    required: true,
                                },
                            ]}

                        >
                            <Select
                                name="category"
                                placeholder="select the Job Category"
                                // onChange={JobCategories}
                                allowClear
                                showSearch
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }

                            // options={JobCategories}
                            >

                                {
                                    JobCategories?.map((data) =>
                                        <Option value={data.id}>
                                            {data.label}
                                        </Option>
                                    )
                                }

                            </Select>

                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col md={20}>
                        <label>Notes for HR (Optional)</label>
                        <Form.Item
                            name="notes_for_hr"
                            rules={[
                                {
                                    message: 'Please enter your Notes for HR ',
                                    required: false,
                                },
                            ]}

                        >
                            <TextArea rows={6} className='input-style' placeholder='Write Notes for HR' maxLength='501' />

                        </Form.Item>
                    </Col>
                </Row>


                <label> Resume/Employment History</label>
                <p style={{ color: '#BDBDBD' }}> (Acceptable Formats: .pdf, jpg, png, doc,docx)</p>

                <Row>
                    <Col md={20}>
                        <Form.Item
                            name="resume"
                            style={{ display: 'flex', flexDirection: 'column', width: '100%' }}

                            rules={[
                                {
                                    message: 'Please upload your resume  or Invalid File Type (Acceptable Formats: .pdf, jpg, png, doc,docx)',

                                    required: false,
                                },

                            ]}

                        >

                            {filesToUpload?.resume ?
                                <Row className='uploadCard'  >
                                    <Col md={20} className='layout-col'>
                                        <p className="ant-upload-drag-icon" style={{ marginTop: '10px', margin: 'auto' }}>
                                            <Image src='../assets/TickDoneIcon.svg' width={160} height={160} preview={false} />
                                        </p>
                                        <br />
                                        <p style={{ margin: 'auto' }}>File uploaded</p>
                                        <p style={{ margin: 'auto' }}>{filesToUpload[`resume-name`]}</p>
                                    </Col>
                                    <Col md={2}>
                                        <button onClick={() => deletePDF('resume')} className='dustbinBtn' />
                                    </Col>
                                </Row>
                                :

                                <Row className='uploadCard'>
                                    <input id='resume' type='file' onChange={(e) => uploadPDF(e.target.files, 'resume')} />
                                </Row>
                            }

                        </Form.Item>
                    </Col>
                </Row>

                <label>Driver's License</label>
                <p style={{ color: '#BDBDBD' }}> (Acceptable Formats: .pdf, jpg, png, doc,docx)</p>

                <Row>
                    <Col md={20}>
                        <Form.Item
                            name="state_driver_license"
                            rules={[
                                {
                                    message: 'Please upload your state Driver License  or Valid File Type (Acceptable Formats: .pdf, jpg, png, doc,docx)',

                                    required: false,
                                },

                            ]}
                            style={{ display: 'flex', flexDirection: 'column' }}

                        >
                            {filesToUpload?.state_driver_license ?
                                <Row className='uploadCard'  >
                                    <Col md={20} className='layout-col'>
                                        <p className="ant-upload-drag-icon" style={{ marginTop: '10px', margin: 'auto' }}>
                                            <Image src='../assets/TickDoneIcon.svg' width={160} height={160} preview={false} />
                                        </p>
                                        <br />
                                        <p style={{ margin: 'auto' }}>File uploaded</p>
                                        <p style={{ margin: 'auto' }}>{filesToUpload[`state_driver_license-name`]}</p>
                                    </Col>
                                    <Col md={2}>
                                        <button onClick={() => deletePDF('state_driver_license')} className='dustbinBtn' />
                                    </Col>
                                </Row>
                                :
                                // <Upload onChange={(options) => uploadPDF(options, 'license')} >
                                //     <p className="ant-upload-drag-icon">
                                //         <InboxOutlined />
                                //     </p>
                                //     <p className="ant-upload-text">Select File</p>
                                // </Upload>
                                <Row className='uploadCard'>
                                    <input id='state_driver_license' type='file' onChange={(e) => uploadPDF(e.target.files, 'state_driver_license')} />
                                </Row>

                            }

                        </Form.Item>
                    </Col>
                </Row>

                {/* <label>Social Security Card</label>
                <p style={{ color: '#BDBDBD' }}> (Acceptable Formats: .pdf, jpg, png, doc,docx)</p>

                <Row>
                    <Col md={20}>
                        <Form.Item
                            name="ssc"
                            rules={[
                                {
                                    message: 'Please upload your social security number or Valid File Type (Acceptable Formats: .pdf, jpg, png, doc,docx)',

                                    required: true,
                                },
                            ]}
                            style={{ display: 'flex', flexDirection: 'column' }}
                        >

                            {filesToUpload?.ssc ?
                                <Row className='uploadCard'  >
                                    <Col md={20} className='layout-col'>
                                        <p className="ant-upload-drag-icon" style={{ marginTop: '10px', margin: 'auto' }}>
                                            <Image src='../assets/TickDoneIcon.svg' width={160} height={160} preview={false} />
                                        </p>
                                        <br />
                                        <p style={{ margin: 'auto' }}>File uploaded</p>
                                        <p style={{ margin: 'auto' }}>{filesToUpload[`ssc-name`]}</p>
                                    </Col>
                                    <Col md={2}>
                                        <button onClick={() => deletePDF('ssc')} className='dustbinBtn' />
                                    </Col>
                                </Row>
                                :

                                <Row className='uploadCard'>
                                    <input id='ssc' type='file' onChange={(e) => uploadPDF(e.target.files, 'ssc')} />
                                </Row>
                            }

                        </Form.Item>
                    </Col>
                </Row> */}
                <Form.Item

                >
                    <Button style={{ background: '#2963AD ', color: 'white', height: '50px', width: '300px', borderRadius: '10px', marginBottom: '50px' }} htmlType="submit">
                        Create Password & Account
                    </Button>
                </Form.Item>
            </Form>
        </div >

    )
}

export default ContactInfoForm